import fsVideoLoader from './fsVideoLoader';

// extends fsVideoLoader with functionality for managing video in story pages
// story script using this script is here:
// 20150805_release/cq-core/foxsports/foxsports-core-ui/src/main/content/jcr_root/etc/designs/fsdigital/foxsports/assets/apps/storyapp/scripts/factories/storyEvents.service.js

var fsStoryVideoLoader = (function(fsVideoLoader) {

	var o = Object.create(fsVideoLoader);

	// init all video and play all video with autoplay true
	o.start = function (storyIndex) {
		fsVideoLoader.startall();
	};

	// if autoplaynum is specified, *only* allows autoplaynum number of videos to
	// be autoplayed and redefines autoplay as false for remaining video data
	// before initialization
	//
	o.initall = function (storyIndex, autoplaynum) {
		autoplaynum = typeof autoplaynum === 'number' ? autoplaynum : Infinity;

		fsVideoLoader.getvideoelementsdata().map(function (data) {
			if (fsVideoLoader.isvideodata_autoplay(data) && 0 >= autoplaynum--) {
				data.autoplay = false;
			}

			return data;
		}).map(function (data) {
			fsVideoLoader.start(data, function (err, e, player) {
				//console.log('player is started!', data, e, player, arguments);
			});
		});
	};

	return o;
}(fsVideoLoader));


export default fsStoryVideoLoader;



// WEBPACK FOOTER //
// ./assets/components/platformPlayer/fsStoryVideoLoader.js